import { render, staticRenderFns } from "./GoodsSearchPreview.vue?vue&type=template&id=4f55deed&scoped=true&"
import script from "./GoodsSearchPreview.vue?vue&type=script&lang=js&"
export * from "./GoodsSearchPreview.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSearchPreview.vue?vue&type=style&index=0&id=4f55deed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55deed",
  null
  
)

export default component.exports